module.exports = {
          srcSet: __webpack_public_path__ + "319906a6f52a9c5879a59201e0f6c10f-500.png"+" 500w",
          images:[ {path: __webpack_public_path__ + "319906a6f52a9c5879a59201e0f6c10f-500.png",width: 500,height: 346}],
          src: __webpack_public_path__ + "319906a6f52a9c5879a59201e0f6c10f-500.png",
          toString:function(){return __webpack_public_path__ + "319906a6f52a9c5879a59201e0f6c10f-500.png"},
          
          width: 500,
          height: 346
        }